<template>
	<div id="tab-header" class="row">
		<div class="col-sm-12">
			<ul id="groups" class="nav nav-tabs attribute-groups">
				<li v-for="tab in tabsTitle" :class="activeTab === tab.title ? 'active': ''"><a :href="'#' + tab.title" data-toggle="tab" tabindex="-1" @click="getCurrentTab(tab.title)">{{ $t(tab.title) }}</a></li>
				<li><a v-access:can="[Const.PERMISSION_ROLE_ADMIN]" href="#calculateTest" data-toggle="tab">{{ $t('testing.calculate.attribute') }}</a></li>
			</ul>
		</div>
	</div>
</template>

<script>
export default {
	name: 'TabHeader',
	props: {
		tabsTitle: {
			type: Array,
			required: true
		},
		localization: {
			type: Object,
			required: true
		},
		activeTab: {
			type: String
		}
	},
	methods: {
		getCurrentTab (tab) {
			this.$emit('current-tab', tab)
		}
	}
}
</script>

<style scoped>

</style>
